import * as React from "react";

import styled from "@emotion/styled";
import { breakpoints } from "../styles/breakpoints";
import { TrustedbyEntity } from "./trusted-by";
import { nanoid } from "nanoid";

const StyledTrustedByLogos = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 0 auto;

  @media (max-width: ${breakpoints.lg}) {
    max-width: 90rem;
  }

  & > * {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: var(--small) var(--small) 0;

    img {
      filter: opacity(0.7);
    }

    @media (max-width: ${breakpoints["2xl"]}) {
      margin: var(--small) var(--small) 0;
    }

    @media (max-width: ${breakpoints.md}) {
      margin: var(--small) var(--xx-small) 0;
    }

    @media (max-width: ${breakpoints.xs}) {
      margin: var(--x-small) var(--micro) 0;
    }
  }

  img {
    height: 60px;
    width: 140px;

    @media (max-width: ${breakpoints.sm}) {
      width: 125px;
    }

    @media (max-width: ${breakpoints.xs}) {
      width: 120px;
    }

    @media (max-width: ${breakpoints["xs"]}) {
      width: 115px;
    }
  }

  .google-partner {
    transform: scale(1.4);
    filter: grayscale(100%);

    @media (max-width: ${breakpoints.sm}) {
      transform: scale(0.7);
    }
  }

  .meta-partner {
    transform: scale(1.1);
    filter: grayscale(100%) opacity(70%);

    @media (max-width: ${breakpoints.sm}) {
      transform: scale(1);
    }
  }

  .microsoft-partner {
    transform: scale(1.3);
    filter: grayscale(100%) opacity(70%);
  }

  .american-fulfillment {
    @media (min-width: ${breakpoints.lg}) {
      transform: scale(1.2);
    }

    @media (max-width: ${breakpoints.sm}) {
      transform: scale(0.7);
    }
  }

  .tiktok-partner {
    transform: scale(0.9);
  }

  .inc-5000 {
    filter: grayscale(100%) opacity(0.55);
    transform: scale(1.1);

    @media (max-width: ${breakpoints.sm}) {
      transform: none;
    }
  }

  .inc-best-workplaces {
    filter: grayscale(100%) opacity(0.5);
  }

  .clutch {
    filter: grayscale(100%) opacity(0.5);
    transform: scale(0.9);
  }

  .inc-power {
    filter: grayscale(100%) opacity(0.5);
  }

  .inc-regionals {
    filter: grayscale(100%) opacity(0.5);
  }
`;

export const TrustedByLogos = ({
  trustedByEntities,
}: {
  trustedByEntities: TrustedbyEntity[];
}) => (
  <StyledTrustedByLogos>
    {trustedByEntities.map((i) => (
      <div key={nanoid()}>
        <img src={i.src} alt={i.alt} className={i.className} style={i.styles} />
      </div>
    ))}
  </StyledTrustedByLogos>
);
